// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"226":"568c70aba8cfc314","353":"9f0744a221fcc620","3238":"d9fd2bc0b13332b9","4071":"1a6f2ebc506107d0","6271":"c6adfb49294a6dfc","6643":"5d3548054d2adfce","9474":"d5d32c4c96e1abd3"}[chunkId] + ".js";
};